import { HeaderThemeSetups } from 'interfaces/HeaderThemeSetups';

const headerThemeSetups: HeaderThemeSetups = {
	wordpress: {
		astra: {
			default: [
				{
					name: 'masthead',
					type: 'id',
					isSticky: false
				}
			]
		},
		Divi: {
			default: [
				{
					untilWidth: 980,
					name: 'main-header',
					type: 'id',
					isSticky: false
				},
				{
					name: 'main-header',
					type: 'id',
					isSticky: true
				}
			]
		},
		generatepress: {
			default: [
				{
					name: 'masthead',
					type: 'id',
					isSticky: false
				}
			]
		},
		'hello-elementor': {
			default: [
				{
					name: 'site-header',
					type: 'id',
					isSticky: false
				}
			]
		},
		kadence: {
			default: [
				{
					untilWidth: 1024,
					name: 'main-header',
					type: 'id',
					isSticky: false
				},
				{
					name: 'mobile-header',
					type: 'id',
					isSticky: false
				}
			]
		},
		lightning: {
			default: [
				{
					name: 'breadSection',
					type: 'class',
					isSticky: false
				}
			]
		},
		neve: {
			default: [
				{
					name: 'header',
					type: 'class',
					isSticky: false
				}
			]
		},
		oceanwp: {
			default: [
				{
					name: 'site-header',
					type: 'id',
					isSticky: false
				}
			]
		},
		sydney: {
			default: [
				{
					untilWidth: 1024,
					name: 'masthead-mobile',
					type: 'id',
					isSticky: false
				},
				{
					name: 'masthead',
					type: 'id',
					isSticky: true
				}
			]
		},
		twentytwenty: {
			default: [
				{
					name: 'site-header',
					type: 'id',
					isSticky: false
				}
			]
		},
		twentytwentyfour: {
			default: [
				{
					name: 'wp-block-template-part',
					type: 'class',
					isSticky: false
				}
			]
		},
		twentytwentythree: {
			default: [
				{
					name: 'wp-block-template-part',
					type: 'class',
					isSticky: false
				}
			]
		},
		twentytwentytwo: {
			default: [
				{
					name: 'wp-block-template-part',
					type: 'class',
					isSticky: false
				}
			]
		}
	}
};

export default headerThemeSetups;
